<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Affiliate</h3>
            <button
              v-on:click="isModalVisible = true, verrors.clear()"
              class="btn btn-red btn-md input-height-15 float-right text-align-right"
              ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Affiliate</button>
            <button class=" btn btn-red btn-md input-height-15 float-right " @click="fetchIndustriesLists(), isIndustryModalVisible = true, industryLoading = true, verrors.clear(), industry = ''" style="margin-right: 20px;">
              <i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Industries
            </button>

          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div>
            <b-card no-body>
              <div class="row tasks_heading_row">
                <div
                  class="bold cursor-pointer col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4"
                  v-on:click="sortMethod('name')"
                  >
                  Affiliate
                  <i v-if="publicSortField == 'name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="publicSortField == 'name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div
                  class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                  v-on:click="sortMethod('status')"
                  >
                  Status
                  <i v-if="publicSortField == 'status' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="publicSortField == 'status' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div
                  class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                  >
                  # of Skill Sets
                </div>
                <div
                  class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding"
                  v-on:click="sortMethod('createdBy')"
                  >
                  Created By
                  <i v-if="publicSortField == 'createdBy' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="publicSortField == 'createdBy' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
              </div>

              <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>


              <b-card-text v-if="affiliatelists.length > 0">
                 <div class="tasklists-row" v-for="(affiliatelist, index) in affiliatelists">
                 <div class="row tasklist-item" style="margin: 0;">
                   <div class="col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4">
                     {{affiliatelist.name}}
                   </div>
                   <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{ affiliatelist.status }}</div>
                   <div class="link col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding">
                      {{affiliatelist.tasklists_count}}
                      <button
                          v-on:click="viewTaskLists(affiliatelist.id)"
                          v-if="affiliatelist.tasklists_count > 0"
                          class="btn btn-dark-grey in-use-button override-padding"
                          >View</button>
                   </div>
                   <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding">{{affiliatelist.created_by}}</div>
                   <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                       <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                       <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                         <li></li>
                         <li></li>
                         <li></li>
                       </ul>
                       <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                         <div class="action-dd-menu" @click="goToEdit(affiliatelist)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                         <div v-if="affiliatelist.status === 'Active'" class="action-dd-menu" @click="viewAccount(affiliatelist.id)"><i class="cursor-pointer fa fa-user-o spacer-icon"></i>View account</div>
                       </div>
                       </div>
                   </div>
                 </div>
                 <div><hr></div>
                 </div>
                 <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper">
                    <b-pagination
                     v-model="currentPage"
                     :total-rows="rows"
                     :per-page="perPage"
                     first-text="First"
                     prev-text="Prev"
                     next-text="Next"
                     last-text="Last"
                     v-bind:hide-goto-end-buttons=true
                     @input="showAffiliateofPaginated()"
                     ></b-pagination>
                 </div>
              </b-card-text>
              <b-card-text v-else-if="loading == false">
                   No affiliate found.
              </b-card-text>
            </b-card>
          </div>


          <CreateTasklistModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading"><h3>Create Affiliate</h3></div>
            <div slot="body" v-if="isModalVisible === true">
              <div class="col-11 override-padding">
                <input v-model="affiliate_name"
                      name="affiliate_name"
                      placeholder="Enter Affiliate Name"
                      class="col-lg-11 input-height-25"
                      v-validate="'required'"
                      maxlength="255" />
                <div v-if="verrors.firstByRule('affiliate_name', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate name is required</div>
                <div v-if="verrors.firstByRule('affiliate_name', 'exists')" class="margin-bottom-5 validate-warning-msg">Affiliate name already exists</div>
              </div>
              <div style="clear: both;" class="margin-bottom-10"></div>
              <div class="col-11 override-padding">
                <b-form-select
                  class="col-lg-9 col-sm-9 col-8 input-height-15"
                  style="height: 30px;"
                  v-model="affiliate_status"
                  name="affiliate_status"
                  v-validate="'required'"
                  :options="affiliate_status_options">
                </b-form-select>
                <button
                    v-on:click="createAffiliate()"
                    class="btn btn-red col-lg-2 col-sm-2 col-3 input-height-25"
                    ><b>Create</b></button>
                <div v-if="verrors.firstByRule('affiliate_status', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate status is required</div>
              </div>
            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
          </CreateTasklistModal>

          <EditTasksModal :isModalVisible="isEditModalVisible" :editTaskTitle="editAffiliateName" :editTaskPriority="editAffiliateStatus" :editTaskId="editAffiliateId" @close="isEditModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading"><h3>Update Affiliate</h3></div>
            <div slot="body" v-if="isEditModalVisible === true">
              <div class="col-12 override-padding">
                <input
                      v-model="editAffiliateName"
                      name="editAffiliateName"
                      id="editAffiliateName"
                      ref="editAffiliateName"
                      placeholder="Enter Affiliate Name"
                      class="col-12 input-height-25"
                      v-validate="'required'"
                      maxlength="255" />
                <div v-if="verrors.firstByRule('editAffiliateName', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate name is required</div>
              </div>
              <div style="clear: both;" class="margin-bottom-10"></div>
              <div class="col-12 override-padding">
                 <div class="col-lg-9 col-12 float-left override-padding">
                   <b-form-select
                     class="col-lg-9 col-sm-9 col-8 input-height-15"
                     style="height: 30px;"
                     v-model="editAffiliateStatus"
                     name="editAffiliateStatus"
                     v-validate="'required'"
                     :options="affiliate_status_options">
                   </b-form-select>
                 </div>
                 <button
                     v-on:click="updateAffiliateAction(editAffiliateId)"
                     class="btn btn-red col-3 float-left input-height-25"
                     style="margin: 0px 0px 0px 0px"
                     ><b>Update</b></button>
                 <div v-if="verrors.firstByRule('editAffiliateStatus', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate status is required</div>
              </div>
              <div style="clear: both;" class="margin-bottom-10"></div>
            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
          </EditTasksModal>

          <TaskListModal :isModalVisible="isTaskListModalVisible" @close="isTaskListModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading">
              <div>Following skill sets are associated with this affiliate :</div>
              <hr>
              <ul>
                <li v-for="tasklist_list in tasklist_lists">
                  {{ tasklist_list.name }}
                </li>
              </ul>
            </div>
            <div slot="body">

            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
          </TaskListModal>


    <CreateIndustriesModal :isModalVisible="isIndustryModalVisible" @close="isIndustryModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Industries</h3></div>
      <div slot="body">
        <div class="col-12 override-padding">
          <div class="col-9 override-padding float-left">
            <input v-model="industry"
                  name="industry"
                  placeholder="Enter Industry Type"
                  class="col-lg-12 input-text form-control"
                  style="line-height: 30px; "
                  maxlength="140" />
          </div>
          <div class="col-3 override-padding float-left">
          <button
              v-on:click="createIndustry()"
              class="btn btn-blue col-12"
              style="line-height: 30px; margin-left: 15px;"
              ><b>Create</b></button>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div v-show="industryLoading" class="loading_show">
          <div class="spinner-border text-danger"></div>
        </div>

        <div class="col-12 override-padding" v-if="industryLoading == false" style="margin-top: 30px;">
          <div class="" style="margin: bottom: 15px;">
            <div class="bold float-left" style="width: 70%; color: #9B9B9B;">Industry Type</div>
            <div class="bold float-left" style="width: 20%;">&nbsp;</div>
            <div style="clear: both;"></div>
          </div>
          <div class="" v-for="(list, index) in industry_lists"  style="margin: bottom: 10px; ">
            <div class="float-left" style="width: 70%; color: #9B9B9B;">{{ list.title }}</div>
            <div class="float-left" @click="deleteIndustriesConfirm(list.id)" style="width: 20%;"><i class="fa fa-times custom-remove" style="cursor: pointer;"></i></div>
            <div style="clear: both;"></div>
          </div>
          <div v-if="industry_lists.length == 0" style="padding-top: 40px;">
            <div class="float-left" style="width: 90%; color: #9B9B9B;">No Industries to display</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </CreateIndustriesModal>

    <DeleteIndustriesModal :isModalVisible="isDeleteIndustriesModalVisible" :id="industry_id"  @close="isDeleteIndustriesModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deleteIndustries(industry_id)">Confirm</button>
      </div>
    </DeleteIndustriesModal>



        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import { store } from '../../store/store';
import CreateTasklistModal from '../admin/create-tasklist-modal.vue';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import EditTasksModal from '../admin/edit-tasks-modal.vue';
import TaskListModal from '../shared/validation_modal_alert.vue';
import CreateIndustriesModal from '../admin/create-tasklist-modal.vue';
import DeleteIndustriesModal from '../shared/delete_modal_alert.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
        data() {
          return {
            isEditModalVisible: false,
            isTaskListModalVisible: false,
            isModalVisible: false,
            loading: false,
            affiliate_status_options: [
              { value: '', text: 'Select Status' },
              { value: 'Active', text: 'Active' },
              { value: 'Inactive', text: 'Inactive' },
            ],
            affiliate_name: '',
            affiliate_status: '',
            masterAdmin: false,
            affiliatelists: [],
            rows: 0,
            perPage: 25,
            currentPage: 1,
            publicSortField: 'name',
            publicSortBy: 'ASC',
            editAffiliateName: '',
            editAffiliateStatus: '',
            editAffiliateId: '',
            tasklist_lists: [],
            searchParameters: {
              account: {},
              admin: {},
              sort: {},
              affiliate: {},
              search_mentee: {},
              search_form: {},
            },
            industry: '',
            isIndustryModalVisible: false,
            industry_lists: [],
            industryLoading: false,
            isDeleteIndustriesModalVisible: false,
            industry_id: '',
          }
        },
        components: {
          UserMenu,
          CreateTasklistModal,
          MasteradminSidebarMenu,
          EditTasksModal,
          TaskListModal,
          CreateIndustriesModal,
          DeleteIndustriesModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            deleteIndustriesConfirm: function(industry_id) {
              this.isDeleteIndustriesModalVisible = true;
              this.industry_id = industry_id;
            },
            deleteIndustries: function(industry_id) {
              this.isDeleteIndustriesModalVisible = false;
              this.showOverlay = true;
              axios('/industries/' + industry_id,
                 {
                   method: 'DELETE',
                 }
               )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchIndustriesLists();
               })
              .catch(error => {

              });
            },
            fetchIndustriesLists: function() {
              this.category_lists = [];
               axios.get('/industries', {

               })
               .then((response) => {
                   this.industry_lists = response.data.industry;
                   this.industryLoading = false;
               })
               .catch(error => {

               });
            },
            doValidateIndustryCreate: function() {
              var vflag = 1;
              if(this.industry == '') {
                this.industryLoading = false;
                alert("Please enter Industry Type");
                vflag = 0;
                return false;
              }
              return vflag;
            },
            createIndustry: function() {
              this.industryLoading = true;
              var vflag = this.doValidateIndustryCreate();
              if(vflag == 1) {
                axios.get('/check-industry-name-exists', {
                  params: {
                    industry: this.industry, 
                  }
                })
                .then((resp) => {
                  var flag = resp.data;
                  if(flag == 1) {

                    axios('/industries',
                       {
                         method: 'POST',
                         data:
                          {
                            industry_title: this.industry,
                          },
                       }
                     )
                    .then((resp) => {
                        this.industry = '';
                        this.fetchIndustriesLists();
                        //this.$emit('close');
                     })
                    .catch(error => {

                    });
                  }
                  else {
                    alert("Industry Type already exists");
                    this.industryLoading = false;
                    return false;
                  }
                })
                .catch(error => {

                });

              }
            },
            showAffiliateofPaginated: function() {
              this.fetchAffiliatesitems();
            },
            goToEdit: function(affiliate) {
              this.verrors.clear()
              this.editAffiliateName = affiliate.name;
              this.editAffiliateStatus = affiliate.status;
              this.editAffiliateId = affiliate.id;
              this.isEditModalVisible = true;
            },
            viewAccount: function(affiliateId) {
              this.searchParameters.affiliate.id = affiliateId;
              store.dispatch('search_parameters', this.searchParameters);
              let routeData = this.$router.resolve({name: 'accountlookupviewlist'});
              window.open(routeData.href, '_blank');
            },
            createAffiliate: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  axios('/affiliate',
                     {
                       method: 'POST',
                       data:
                        {
                          name: this.affiliate_name,
                          status: this.affiliate_status,
                        },
                     }
                   )
                  .then((resp) => {
                      this.affiliate_name = '';
                      this.affiliate_status = '';
                      this.fetchAffiliatesitems();
                      this.isModalVisible = false;
                      this.$emit('close');
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                    const fieldErrors =  [];
                    // var errMsgObj = error.response.data.message;
                    var errMsgObj = JSON.parse(error.response.data.message);
                    Object.keys(errMsgObj).map(key => {
                      var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                      fieldErrors.push(newFieldErr);
                    });
                    this.$validator.errors.add(fieldErrors);
                  });
                }
              })
              .catch(() => {

              });

            },
            updateAffiliateAction: function(affiliateId) {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  axios('/affiliate/' + affiliateId,
                     {
                       method: 'PATCH',
                       data:
                        {
                          name: this.editAffiliateName,
                          status: this.editAffiliateStatus,
                        },
                     }
                   )
                  .then((resp) => {
                      this.editAffiliateName = '';
                      this.editAffiliateStatus = '';
                      this.fetchAffiliatesitems();
                      this.isEditModalVisible = false;
                   })
                  .catch(error => {

                  })

                }
              })
              .catch(() => {

              });
            },
            viewTaskLists: function(affiliateId) {

              const params = { affiliateId: affiliateId }
              axios.get('/affiliate/tasklists', {
                  params: params
              })
              .then((resp) => {
                  this.tasklist_lists = resp.data;
                  this.isTaskListModalVisible = true;
              })
              .catch(error => {

              });

            },
            fetchAffiliatesitems: function() {
              this.loading = true;

              const params = { _page: this.currentPage }
              if (this.publicSortField) {
                params.sortfield = this.publicSortField
              }
              if (this.publicSortBy) {
                params.sortby = this.publicSortBy
              }
              axios.get('/affiliate', {
                  params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.affiliatelists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
            toggleDropdown (id) {
                document.getElementById(id).classList.toggle("show");
            },
            hideActionMenu(e) {
               var matches = document.getElementsByClassName('dropdown-content');
               for (var i=0; i<matches.length; i++) {
                 var container = document.getElementById('dropdown-container'+ i);

                 if (!container.contains(e.target)) {
                      if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                         document.getElementById('actionDropdown' + i).classList.remove('show');
                      }
                 }
               }
             },
             sortMethod: function(field) {
               this.publicSortField = field;
               if(this.publicSortBy == 'ASC') {
                 this.publicSortBy = 'DESC';
               }
               else {
                 this.publicSortBy = 'ASC';
               }
               this.fetchAffiliatesitems();
             },
        },
        mounted() {
           document.addEventListener('click', this.hideActionMenu);
        },
        beforeDestroy() {
           document.removeEventListener('click', this.hideActionMenu);
        },
        created() {

          var roles = store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          this.fetchAffiliatesitems();


        },
}
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.in-use-button {
  width: 60px;
  margin-left: 5px;
  padding: 2px 0px;
  font-size: 12px;
  border-radius: 46%;
  line-height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view_affiliate_list.vue